export const configAuth0 = {
  audience: 'https://cardinal-api.azurewebsites.net',
  domain: 'dev-jymb8w8n.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0CLIENT_ID,
  clientSecret:
    'NkXSAoVjlneaViQzGOE7MEcouYULUJ9X0SJ9uDgFahqb7S5v6P6fTOhnBYyFboNK',
  auth0Url: 'https://dev-jymb8w8n.us.auth0.com/',
  bdd: 'Username-Password-Authentication',
  grantType: 'http://auth0.com/oauth/grant-type/passwordless/otp',
  scope: 'email profile openid offline_access'
};

export const config = {
  baseUrlCustomers:
    process.env.REACT_APP_BASE_URL ?? 'https://cardinal-api.azurewebsites.net',
  baseUrlBlackBox: 'https://ase-cardinal-api-blackbox-dev.azurewebsites.net'
};

export const googleApiKey = 'AIzaSyCW0wvM-DRN7xxmRPHKjvlIU8r0HOG-MxM';
